<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->

      <div class="popup-content">
        <p class="popup-content-desc1">Consume Growth Reward ARG First on</p>
        <p class="popup-content-desc2">(Can select more than one)</p>

        <!-- 选择列表 -->
        <div class="popup-content-main">
          <div
            class="item"
            v-for="item in selectItems"
            :class="{ actived: item.isActived }"
            @click="handleSelect(item.id)"
            :key="item.id"
          >
            <!-- <div class="item-circle"></div> -->
            <div class="item-text">
              {{ item.text }}
            </div>
          </div>
        </div>

        <!-- 一键全选 -->
        <div class="popup-content-select" @click="handleSelectAll">
          <div v-if="!isSelectAll" class="popup-content-select-circle"></div>
          <img
            v-else
            :src="
              require('@/assets/images/YuliApp/storageActivity/storageUpgrade/icon_yes@2x.png')
            "
          />
          <div class="popup-content-select-text">Select All</div>
        </div>

        <!-- 一键取消 -->
        <!-- <div class="popup-content-cancel" @click="handleCancelAll">
          <div v-if="!isCancelAll" class="popup-content-cancel-circle"></div>
          <img
            v-else
            :src="
              require('@/assets/images/YuliApp/storageActivity/storageUpgrade/icon_yes@2x.png')
            "
          />
          <div class="popup-content-cancel-text">Cancel All</div>
        </div> -->

        <div class="popup-content-desc3">
          <p class="popup-content-desc3-star">*</p>
          <p class="popup-content-desc3-text">
            When you have selected any of the options, the consumption of ARG
            will deduct from the growth reward first, instead of the ARG earned.
          </p>
        </div>

        <!-- 分割线 -->
        <div class="popup-content-divide">
          <img
            :src="
              require('@/assets/images/YuliApp/storageActivity/storageUpgrade/com_dividing_star@2x.png')
            "
          />
        </div>

        <div class="operation">
          <div class="cancel" @click="handleClose">Cancel</div>

          <div class="confirm" @click="debounce(handleConfirm, 300)()">
            Confirm
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <!-- <div class="popup-btn" @click="handleClose">
        <img
          src="@/assets/images/YuliApp/storageActivity/icon_delete_nor@2x.png"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import hookStoreState from "@/utils/useState.js";
import { PRIZE_LIST } from "../../constants/storagePrize";
import { postGrowthRewardConfig } from "@/api/activity.js";
export default {
  props: {
    growth_select_items: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    growth_select_items: {
      handler(value) {
        this.growthSelectItems = value;
        let count = 0;
        this.selectItems.forEach((item, index) => {
          if (this.growthSelectItems.includes(item.id)) {
            item.isActived = true;

            count += 1;
          } else {
            item.isActived = false;
          }
        });

        count === 4 ? (this.isSelectAll = true) : (this.isSelectAll = false);
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props, { emit }) {
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });

    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(
      statusBarHeight.value + window.innerHeight * 0.1 - 20
    );
    const prize_list = ref([]);

    const growthSelectItems = ref([]); //服务请求配置项
    // const isCancelAll = ref(false);
    const isSelectAll = ref(false);

    // const isCancel = ref(false);
    // const isConfirm = ref(false);

    const selectItems = ref([
      {
        id: "breed",
        text: "Breeding",
        isActived: false,
      },
      {
        id: "market_good",
        text: "Buying items in the shop",
        isActived: false,
      },
      {
        id: "level_upgrade",
        text: "Upgrading Yuli",
        isActived: false,
      },
      {
        id: "chip_upgrade",
        text: "Upgrading Chips",
        isActived: false,
      },
    ]);

    onMounted(() => {
      prize_list.value = PRIZE_LIST;
    });

    /**
     * 处理单个选择
     */
    const handleSelect = (id) => {
      let count = 0;
      selectItems.value.forEach((item, index) => {
        if (item.id === id) {
          item.isActived = !item.isActived;
          // isCancelAll.value = false;
        }

        if (item.isActived === true) {
          count += 1;
        }
      });

      count === 4 ? (isSelectAll.value = true) : (isSelectAll.value = false);
    };

    /**
     * 处理一键全选
     */
    const handleSelectAll = () => {
      isSelectAll.value = !isSelectAll.value;
      if (isSelectAll.value) {
        selectItems.value.forEach((item, index) => {
          item.isActived = true;
        });
      } else {
        selectItems.value.forEach((item, index) => {
          item.isActived = false;
        });
      }

      // isCancelAll.value = false;
    };

    /**
     * 处理一键全取消
     */
    const handleCancelAll = () => {
      selectItems.value.forEach((item, index) => {
        item.isActived = false;
      });
      // isCancelAll.value = true;
      isSelectAll.value = false;
    };

    /**
     * 防抖
     */
    function debounce(fun, delay) {
      return function (args) {
        let that = this;
        let _args = args;
        clearTimeout(fun.id);
        fun.id = setTimeout(function () {
          fun.call(that, _args);
        }, delay);
      };
    }

    /**
     * 确定
     */
    const handleConfirm = () => {
      const params = [];
      selectItems.value.forEach((item, index) => {
        if (item.isActived === true) {
          params.push(item.id);
        }
      });

      // isConfirm.value = true;
      requestPostGrowthRewardConfig(params);
    };

    /**
     * 请求配置成长基金消耗
     */
    const requestPostGrowthRewardConfig = (pramas) => {
      return postGrowthRewardConfig({ gr_preference: pramas })
        .then((res) => {
          emit("close", false, "refresh");
        })
        .catch((error) => {
          console.log("error++++++++++");
        });
    };

    /**
     * 处理关闭
     */
    const handleClose = () => {
      // isCancel.value = true;
      emit("close", false);
    };

    return {
      popup_top,
      handleClose,
      prize_list,
      selectItems,
      handleSelect,
      handleSelectAll,
      handleCancelAll,
      isSelectAll,
      // isCancelAll,
      handleConfirm,
      growthSelectItems,
      debounce,
      // isCancel,
      // isConfirm,
    };
  },
};
</script>

<style lang="less" scoped>
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    // margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-content {
      box-sizing: border-box;
      padding: 50px 0 0 0;
      width: 352px;
      height: 531px;
      background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/bg_set@2x.png");
      background-size: 100% 100%;

      &-desc1 {
        color: rgba(51, 50, 55, 1);
        font-size: 16px;
        font-weight: 700;
        font-family: "PingFang SC";
        text-align: center;
      }
      &-desc2 {
        width: 100%;
        box-sizing: border-box;
        color: rgba(89, 94, 114, 1);
        font-size: 12px;
        font-weight: 500;
        font-family: "PingFang SC";
        text-align: left;
        line-height: 17px;
        padding-left: 36px;

        margin-bottom: 12px;
      }

      &-main {
        .item {
          box-sizing: border-box;
          margin: 0 auto;
          width: 289px;
          height: 46px;
          // border: 1px solid #000000;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          padding-left: 51px;
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/png_list@2x.png");
          background-size: 100% 100%;

          margin-bottom: 10px;
          color: rgba(78, 83, 102, 1);

          &-text {
            width: 100%;

            font-size: 18px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: left;
            line-height: 46px;
          }
        }
        .actived {
          color: rgba(217, 217, 217, 1);
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/png_list_n@2x.png");
          background-size: 100% 100%;
          // background-color: red;
        }
        .item:nth-last-child(1) {
          margin-bottom: 8px;
        }
      }

      &-select,
      &-cancel {
        box-sizing: border-box;
        margin: 0 auto 13px auto;
        width: 289px;
        height: 20px;
        padding-left: 19px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &-circle {
          box-sizing: border-box;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 0.83px solid rgba(105,112,138,1);
          margin-right: 15px;
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 13px;
          margin-left: -2px;
        }
        &-text {
          color: rgba(50, 57, 81, 1);
          font-size: 14px;
          font-weight: 500;
          font-family: "PingFang SC";
          text-align: left;
        }
      }

      &-desc3 {
        display: flex;
        margin: 0 auto 18.5px auto;
        width: 271px;
        &-star {
          color: rgba(222, 55, 19, 1);
          font-weight: 500;
          font-family: "PingFang SC";
          text-align: left;
          font-size: 14px;
          margin-right: 5px;
        }
        &-text {
          color: rgba(89, 94, 114, 1);
          font-weight: 500;
          font-family: "PingFang SC";
          text-align: left;
          font-size: 12px;
          line-height: 16px;
        }
      }
      &-divide {
        margin: 0 auto;
        position: relative;
        width: 317px;
        height: 8px;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .operation {
        margin-top: 9.5px;
        box-sizing: border-box;
        padding: 0 36px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .cancel,
        .confirm {
          width: 130px;
          height: 44px;
          line-height: 44px;

          color: rgba(218, 227, 235, 1);
          font-size: 16px;
          font-weight: 700;
          font-family: "PingFang HK";
          text-align: center;

          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/cancel_button.png");
          background-size: 100% 100%;
        }
        .confirm {
          background-image: url("~@/assets/images/YuliApp/storageActivity/storageUpgrade/comfirm_button.png");
          background-size: 100% 100%;
        }
      }
    }

    &-btn {
      // margin-top: 28px;
      position: absolute;
      z-index: 999;
      bottom: -70px;
      width: 40px;
      height: 40px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and (max-height: 670px) {
  .page {
    .popup {
      margin-top: 25px !important;
      &-btn {
        position: absolute;
        z-index: 999;
        bottom: -24px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
